export default {
	computed: {
		_formatDate: function () {
			return $sessao.getDateFormat()
		}
	},

	methods: {
		_dateFormat(data, format, formatRetorno) {
			return new moment(data, format).format(formatRetorno)
		},

		_dateToDateSQL(data, mascara) {
			if (data == '' || data == null || _.isNil(data)) {
				return ''
			}

			if (mascara == 'DD/MM/YYYY') {
				var dt = data.split('/')
				return dt[2] + '-' + dt[1] + '-' + dt[0]
			}

			if (mascara == 'MM/DD/YYYY') {
				var dt = data.split('/')
				return dt[2] + '-' + dt[0] + '-' + dt[1]
			}
		},

		_dateTimeToDateSQL(data, mascara) {
			if (data == '' || data == null || _.isNil(data)) {
				return ''
			}

			if (mascara == 'DD/MM/YYYY HH:MM:SS') {
				var item = data.split(' ')
				var dt = item[0].split('/')
				return dt[2] + '-' + dt[1] + '-' + dt[0] + ' ' + item[1]
			}

			if (mascara == 'MM/DD/YYYY HH:MM:SS') {
				var item = data.split(' ')
				var dt = item[0].split('/')
				return dt[2] + '-' + dt[0] + '-' + dt[1] + ' ' + item[1]
			}

			if (mascara == 'DD/MM/YYYY HH:MM') {
				var item = data.split(' ')
				var dt = item[0].split('/')
				return dt[2] + '-' + dt[1] + '-' + dt[0] + ' ' + item[1]
			}

			if (mascara == 'MM/DD/YYYY HH:MM') {
				var item = data.split(' ')
				var dt = item[0].split('/')
				return dt[2] + '-' + dt[0] + '-' + dt[1] + ' ' + item[1]
			}
		},

		_SQLDateToDate(data, mascara) {
			if (data == '' || data == null || _.isNil(data)) {
				return ''
			}

			if (mascara == 'DD/MM/YYYY') {
				var dt = data.split('-')
				return dt[2] + '/' + dt[1] + '/' + dt[0]
			}

			if (mascara == 'MM/DD/YYYY') {
				var dt = data.split('-')
				return dt[1] + '/' + dt[2] + '/' + dt[0]
			}
		},

		_SQLDateToMonthDay(data, mascara) {
			if (data == '' || data == null || _.isNil(data)) {
				return ''
			}

			if (mascara == 'DD/MM/YYYY') {
				var dt = data.split('-')
				return dt[2] + '/' + dt[1]
			}

			if (mascara == 'MM/DD/YYYY') {
				var dt = data.split('-')
				return dt[1] + '/' + dt[2]
			}
		},

		_SQLDateToDateTime(data, mascara) {
			if (data == '' || data == null || _.isNil(data) || data == '0000-00-00' || data == '0000-00-00 00:00:00') {
				return ''
			}

			if (mascara == 'DD/MM/YYYY HH:MM') {
				var dt = data.split(' ')
				return (
					dt[0].split('-')[2] +
					'/' +
					dt[0].split('-')[1] +
					'/' +
					dt[0].split('-')[0] +
					' ' +
					dt[1].split(':')[0] +
					':' +
					dt[1].split(':')[1]
				)
			}

			if (mascara == 'MM/DD/YYYY HH:MM') {
				var dt = data.split(' ')
				return (
					dt[0].split('-')[1] +
					'/' +
					dt[0].split('-')[2] +
					'/' +
					dt[0].split('-')[0] +
					' ' +
					dt[1].split(':')[0] +
					':' +
					dt[1].split(':')[1]
				)
			}

			if (mascara == 'DD/MM/YYYY HH:MM:SS') {
				var dt = data.split(' ')
				return dt[0].split('-')[2] + '/' + dt[0].split('-')[1] + '/' + dt[0].split('-')[0] + ' ' + dt[1]
			}

			if (mascara == 'MM/DD/YYYY HH:MM:SS') {
				var dt = data.split(' ')
				return dt[0].split('-')[1] + '/' + dt[0].split('-')[2] + '/' + dt[0].split('-')[0] + ' ' + dt[1]
			}

			if(mascara == 'HH:MM'){
				var dt = data.split(' ')
				return  dt[1].slice(0,5)
			}
		},

		_getDayMes(dia, mes, ano) {
			var dt = (dia < 10 ? '0' + dia : dia) + '/' + mes + '/' + ano
			var d = new moment(dt, 'DD/MM/YYYY')
			return this._traducao('diasSemanaPos', d.weekday())
		},

		_getSabDom(dia) {
			var dt = (dia < 10 ? '0' + dia : dia) + '/' + this.form.mes + '/' + this.form.ano
			var d = new moment(dt, 'DD/MM/YYYY')
			var t = d.day()
			return t == 0 || t == 6 ? true : false
		},

		_utcToBrt(dateUtc, format){
			const utcTime = new Date(dateUtc);
			const options = { timeZone: 'America/Sao_Paulo' };
		  
			if (format === 'data') {
			  options.year = 'numeric';
			  options.month = 'numeric';
			  options.day = 'numeric';
			} else if (format === 'hora') {
			  options.hour = 'numeric';
			  options.minute = 'numeric';
			  options.second = 'numeric';
			}
			return utcTime.toLocaleString('pt-BR', options);
		  },

		  _convertUtcToBrt(date) {
			const utcDate = new Date(date);
			const brtOptions = { timeZone: 'America/Sao_Paulo' };
	
			  return utcDate.toLocaleDateString('pt-BR', brtOptions);
			
		  },

		  _convertHoraUtcToBrt(hora) {
			const [hours, minutes, seconds] = hora.split(':');
			const utcDate = new Date();
			utcDate.setUTCHours(hours);
			utcDate.setUTCMinutes(minutes);
			utcDate.setUTCSeconds(seconds);
			
			const brtOptions = { timeZone: 'America/Sao_Paulo' };
			
			
			  return utcDate.toLocaleTimeString('pt-BR', brtOptions);

		  },

		_convertDataBrForUS(dataHora){
			if (typeof dataHora !== 'string' || !dataHora.includes(' ')) {
				return 'Data e hora inválidas';
			}
		
			const partes = dataHora.split(' ');
			const dataParte = partes[0];
			const horaParte = partes[1];
	
			if (!dataParte.includes('/') || dataParte.split('/').length !== 3) {
				return 'Formato de data inválido';
			}
	
			const partesData = dataParte.split('/');
			const dia = partesData[0];
			const mes = partesData[1];
			const ano = partesData[2];
	
			if (!horaParte.includes(':') || horaParte.split(':').length !== 2) {
				return 'Formato de hora inválido';
			}
	
			return `${ano}-${mes}-${dia} ${horaParte}`;
		}
		  

		
	}
}